import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SpinnerService } from './spinner.service';

@Component({
    selector: 'qnect-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpinnerComponent implements OnInit {

    objLoaderStatus: boolean;

    constructor(
        private loaderService: SpinnerService) {
        this.objLoaderStatus = false;
    }

    ngOnInit() {
        this.loaderService.loaderStatus.subscribe((val: boolean) => {
            this.objLoaderStatus = val;
        });
    }

}
